import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>GARDEN POÈTE</h3>
            <p className="footer-heritage">Since 2019</p>
            <p className="footer-tagline">
              A little wedding,<br />
              like a fairytale village
            </p>
          </div>

          <div className="footer-nav">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/venue">Venue</Link></li>
              <li><Link to="/catering">Catering</Link></li>
              <li><Link to="/flower">Flower</Link></li>
              <li><Link to="/your-wedding">Pricing</Link></li>
            </ul>
          </div>

          <div className="footer-follow">
            <h4>Follow</h4>
            <a href="https://instagram.com/garden_poete" target="_blank" rel="noopener noreferrer">Instagram</a>
            <span className="social-note">@garden_poete</span>
            <a href="https://map.naver.com/p/entry/place/1616124276?lng=126.9237118&lat=37.5502111&placePath=%2Fhome&entry=plt&searchType=place&c=15.00,0,0,0,dh" target="_blank" rel="noopener noreferrer" style={{marginTop: '10px', display: 'block'}}>네이버플레이스</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 Garden Poète • Since 2019 • 6 Years of Stories</p>
          <p className="footer-location">Hongdae, Seoul</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
